import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Itemset, ItemsetResult } from "../../../../store/viewmodels/ItemsetViewModel";
import { Item } from "../../../../store/viewmodels/ItemViewModel";
import { Task } from "../../../../store/viewmodels/TaskViewModel";
import { getNextUrl, postCheck } from "../../../../utils/TaskNavigationServices";
import { useAppDispatch, useAppSelector } from "../../../../store/Hooks";
import { StudentData } from '../../../../store/viewmodels/StudentViewModel';
import CombineCards from "./CombineCards";
import { addAnswerToSet, addItemSet, addStudentId, postAnswerSet, resetAsSliceState, setEndTime, setStartTime } from "../../../../store/AnswerSetSlice";
import { Answer } from "../../../../store/viewmodels/AnswerViewModel";
import ModalWrapper from "../../../utils/modal/ModalWrapper";
import FeedBack from "../FeedBack";
import Header from "../Header";

export interface StudentCombineItemProps {
    task: Task,
    itemset: Itemset,
    item: Item
}

function StudentCombineItem(props: StudentCombineItemProps) {
    const dispatch = useAppDispatch();
    const studentData: StudentData = useAppSelector(state => state.studentData);
    let aStartTime = new Date();
    let nextUrl = getNextUrl(props.itemset, props.item, props.task, studentData.student.active_item_sets);
    const history = useHistory();

    const [isModalVisible, setModalVisible] = React.useState(false);
    const [content, setContent] = React.useState(<></>);
    const showModal = () => {
        return;
    }

    const [goForward, setForward] = React.useState(false);

    React.useEffect(() => {
        const itemset: ItemsetResult = { id: props.itemset.id, name: props.itemset.name, type: props.itemset.type }
        dispatch(addStudentId(studentData.student.id));
        dispatch(addItemSet(itemset));
        let asStartTime = new Date();
        dispatch(setStartTime(asStartTime.toISOString()));

        return () => { }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const checkAnswer = () => {
        let splitCount = props.item.child_items.length;
        let answerArray = answerValue.split(";", splitCount);
        if (answerArray.length < splitCount) return false;
        for (let i: number = 0; i < answerArray.length; i++) {
            let answers = answerArray[i].split("|");
            if (!(answers[0] === answers[1])) {
                return false;
            }
        }
        return true;
    }

    const commitAnswer = () => {
        let noFeedBack = props.task.no_feedback;
        let time = noFeedBack ? 0 : 1500;

        if (!noFeedBack) {
            let feedBack = checkAnswer() ? <FeedBack correct={true} itemId={props.item.id} /> : <FeedBack correct={false} itemId={props.item.id} />;
            setContent(feedBack);
            setModalVisible(true);
        }

        setTimeout(() => {
            history.push(nextUrl);
            setModalVisible(false);
            let answer: Answer = {} as Answer;
            let aEndTime = new Date();
            answer.item = props.item.id;
            answer.value = answerValue;
            answer.end_time = aEndTime.toISOString()
            answer.start_time = aStartTime.toISOString()
            dispatch(addAnswerToSet(answer))
            const postAnswerSetCheck: boolean = postCheck(props.itemset, props.item, props.task, studentData.student.active_item_sets);
            if (postAnswerSetCheck) {
                let asEndTime = new Date()
                dispatch(setEndTime(asEndTime.toISOString()))
                dispatch(postAnswerSet())
                    .then(() => {
                        dispatch(resetAsSliceState())
                    })
            } else {
                setAnswerArray([]);
                setClear(clear!);
                setAnswerValue("");
                setForward(false);
            }
        }, time)
    }

    const [answerArray, setAnswerArray] = React.useState([] as any);
    const [clear, setClear] = React.useState(false);
    const [answerValue, setAnswerValue] = React.useState("");
    const [firstRow, setFirstRow] = React.useState([] as any);

    useEffect(() => {
        if (answerArray.length >= props.item.child_items.length) {
            let ans: string = "";

            if (answerArray.length === firstRow.length) {
                for (let i: number = 0; i < answerArray.length; i++) {
                    let a = answerArray[i].item.content;
                    let correct = firstRow[i].item.content;

                    ans = ans + a + "|" + correct + ";"
                }
            }
            setAnswerValue(ans);
            setForward(true);
        } else {
            setForward(false);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [answerArray])

    useEffect(() => {
        setForward(false);
    }, [clear])

    let cards = <CombineCards item={props.item} answer={answerArray} setAnswer={setAnswerArray} clear={clear} setClear={setClear} setFirstRow={setFirstRow} />;
    let cardCount = props.item.child_items?.length;
    let mainCss ="";

    switch (cardCount) {
        case 1:
        case 2: {
            //TODO: 2 parin asettelu paremmin, pelkkä leveyden säätö ei riitä
            mainCss = " sm:max-w-3/5 md:max-w-1/2 lg:max-w-3/5 xl:max-w-1/2 2xl:max-w-1/2 6xl:max-w-1/2 ";
            break;
        }
        case 3: {
            mainCss = " sm:max-w-1/2 lg:max-w-2/3 xl:max-w-1/2 ";
            break;
        }
        case 4: {
            mainCss = " sm:max-w-1/2 md:max-w-2/3 6xl:max-w-3/5 "
            break;
        }
        default: mainCss = " max-w-4/5 ";
    }

    return (
        <div className="h-fit w-fit">
            <ModalWrapper isVisible={isModalVisible} onBackdropClick={showModal} content={content} type={"feedBack"} />
            <div className="h-5/6 justify-center my-auto">
                <div className="h-5/6 w-full flex justify-center">
                    <div className={"mx-auto " + mainCss}>
                        {cards}
                    </div>
                </div>
                <div className="h-1/6">
                    <Header setClear={setClear} commitAnswer={commitAnswer} goForward={goForward} type={"combine"} />
                </div>
            </div>
        </div>
    );
}

export default StudentCombineItem;